import { ICreateDriverState } from 'apps/fleet-planner/types'
import { IStore } from 'apps/fleet-planner/utils/types/store'

export const driverStateSelector = (state: IStore): ICreateDriverState => state.driver
